import styles from './CardActivationPage.css';
import BodyText from '../shared/Typography/BodyText';
import Title from '../shared/Typography/Title';
import useTranslation from '../../localization/i18n.context';
import Button from '../shared/Button/Button';
import TextField from '../shared/TextField/TextField';
import { useEffect } from 'preact/hooks';
import { TrackingEvent } from '../../sdk/tracking.event';

const CARD_ACTIVATION_CODE_LENGTH = 12;

export default function ActivationCodeStep({
  value,
  onInput,
  onButtonClick,
  organizationCode,
}) {
  const { t, getOrganization } = useTranslation();

  const isButtonEnabled =
    value &&
    value.length === CARD_ACTIVATION_CODE_LENGTH &&
    /\d{12}/.test(value);

  useEffect(() => {
    TrackingEvent.trigger(
      TrackingEvent.Events.ACTIVATION_CODE_SCREEN_SHOW,
      TrackingEvent.Sources.CAAS,
    );
  }, []);

  return (
    <main className={styles.main}>
      <div className={styles.content} data-testid="activation-code">
        <div className={styles.head}>
          <Title
            text={t('Enter your activation code')}
            className={styles.title}
          />

          <BodyText
            data-testid="activation-code-info"
            text={t('Your 12 digit activation code is written in the envelop')}
          />
        </div>
        <div className={styles['form-controller']}>
          <TextField
            label={t('Activation code')}
            placeholder="000123456789"
            inputMode="numeric"
            pattern="\d*"
            maxlength={CARD_ACTIVATION_CODE_LENGTH}
            value={value}
            onInput={e => {
              onInput('activationCode', e.target.value);
            }}
          />
        </div>

        {/*<img*/}
        {/*  src={*/}
        {/*    getCardAssetURL(organizationCode, CardType.CARD_ACTIVATION_NUMBER)*/}
        {/*  }*/}
        {/*  className={styles.image}*/}
        {/*/>*/}
      </div>
      <div className="fixed-cta">
        <Button fullWidth onClick={onButtonClick} disabled={!isButtonEnabled}>
          {t('Continue')}
        </Button>
      </div>
    </main>
  );
}
